export class LocalizedText{
    localizedTextId : number = 0;
    languageId : number = 0;
    localizedFieldId : number = 0;
    localizedRowId : string | undefined;
    text : string = '';
}